Ext.define('SA.CrosstabAttributesPanelSubheader', {
    singleton: true,

    create() {
        return SA.EditPanelSubheader.create([
            {cls: 'sa-crosstab-attributes-panel-subheader-row-label', text: 'Row'},
            {cls: 'sa-crosstab-attributes-panel-subheader-column-label', text: 'Col'}
        ]);
    }
});